import { SET_GROUP_MEMBER_DETAILS } from "../type";


const initialState = {
    groupMemberDetails: null,
}
export const groupMemberDetailReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_GROUP_MEMBER_DETAILS:
            return {
                ...state,
                groupMemberDetails: action.payload.groupMemberDetails,
            };
        default:
            return state

    }
}